module.exports = __webpack_public_path__ + "img/link_game.30430560.png";